module.exports = __webpack_public_path__ + "img/person.5b93643e.svg";